import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { MutationOptions, useMutation } from '@tanstack/react-query';
import { User } from '../features/auth/types';

export interface AuthCredentialsDTO {
  username: string;
  password: string;
  language: string;
}

export interface AuthUser {
  token: string;
  user: User;
}

export const authUser = async (credentials: AuthCredentialsDTO): Promise<AuthUser> => {
    try {
        const response = await axios.post('/auth', {
            Username: credentials.username,
            Password: credentials.password,
            Language: credentials.language,
        });
        return response.data;
    } catch {
         throw new Error("Error inesperado");
    }
};



// Hook personalizado para autenticar
export const useAuth = ({ config }: { config?: MutationOptions<AuthUser, Error, AuthCredentialsDTO> } = {}) => {
  const navigate = useNavigate();
    const login = (token: string, username: string, idPersona: string) => {
    localStorage.setItem('token', token);
    localStorage.setItem('username', username);
    localStorage.setItem('idPersona', idPersona);
    navigate('/pendingSurveys');
  };

  const logout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const { mutateAsync: authenticate, isError, error } = useMutation<AuthUser, Error, AuthCredentialsDTO>({
    mutationFn: authUser,
    ...config,
      onSuccess: (data) => {
          login(data.token, data.user.username, data.user.id); 
    },
  });

  return {
    authenticate, 
    isError,
    error,
    logout, 
  };
};

export const register = async (usernameValue: string, idClient: number, idSurvey:  number, language: string ) => {
    console.log("api register" + usernameValue);
    try {
        const response = await axios.get('/auth/register/login',  {
            params: {
                username : usernameValue,
                idClient: idClient,
                idSurvey: idSurvey,
                language: language
            }
        });
        return response.data;
    } catch {
        
       throw new Error("Error inesperado");
        
    }
}


